import { render } from "./layout-detached.vue?vue&type=template&id=0a65ca66"
import script from "./layout-detached.vue?vue&type=script&lang=js"
export * from "./layout-detached.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__